import { render } from "./stickySummary.vue?vue&type=template&id=02bc6668&scoped=true"
import script from "./stickySummary.vue?vue&type=script&lang=js"
export * from "./stickySummary.vue?vue&type=script&lang=js"

import "./stickySummary.vue?vue&type=style&index=0&id=02bc6668&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bc6668"]])

export default __exports__